import React from "react";
import { Route, useLocation } from "react-router-dom";
import { Login } from "../public";
import Application from "./Application";
import Website from "./Website";
import { APP } from "../common/constant/application";
import Header from "../components/website/header";
import Footer from "../components/website/footer";

const AppWrapper = () => {
  let location = useLocation();
  let loginSession = APP.loggedin;
  switch (location.pathname) {
    case `${process.env.PUBLIC_URL}/login`: {
      return (
        <React.Fragment>
          <Header minimal />
          <Route
            path={`${process.env.PUBLIC_URL}/login`}
            exact
            component={Login}
          />
          <Footer />
        </React.Fragment>
      );
    }
    // case "/dashboard": {

    //     return loginSession ? <Route path="/dashboard" component={Application} /> :
    //         <React.Fragment>
    //             <Header />
    //             <Route path="/" component={Login} />
    //             <Footer />
    //         </React.Fragment>;
    // }
    case `${process.env.PUBLIC_URL}`: {
      return <Route path={`${process.env.PUBLIC_URL}`} component={Website} />;
    }
    default:
      console.log(">>>>", location.pathname);
      return loginSession ? <Application /> : <Website />;
  }
};

export default AppWrapper;
